<template>
    <div class='container'>
        <div class='clause'>
            <h3 class='text text-center'>{{content.title}}</h3>
            <p v-html='content.date'/>
            <p>{{content.abstraction.context}}</p>
            <ul class='clause-list indent'>
                <li v-for='(addition, index) in content.abstraction.specifics' :key='`specific-${index}`'>
                    {{'i'.repeat(index + 1)}}.{{addition}}
                </li>
            </ul>
            <div class='clause-section' v-for='(clause, index) in content.protocols' :key='`clause-${index}`'>
                <h4>{{index + 1}}. {{clause.name}}</h4>
                <p v-html='clause.intro'/>
                <ul class='clause-list indent'>
                    <li v-for='(detail, dindex) in clause.details' :key='`detail-${dindex}`'>
                        <span v-if='detail.context'>
                            {{index + 1}}.{{dindex + 1}} 
                        </span>
                        <span v-if='detail.subtitle'>{{detail.subtitle}}<br></span>
                        <span v-html="detail.context"/>

                        <ul class='clause-list'>
                            <li v-for='(subject, sindex) in detail.subjects' :key='`subject-${sindex}`'>
                                {{sindex + 1}}) <span v-html="subject"></span>
                            </li>
                        </ul>
                    </li>
                    <li>{{clause.end}}</li>
                </ul>
            </div>
            <regulation-footer/>
        </div>
    </div>
</template>

<script>
    import { USER_PRIVACY } from '@/clause/regulation/agent.privacy'
    import RegulationFooter from '@/components/footprint'
    
    export default {
        components: {
            RegulationFooter
        },
        data () {
            return {
                content: USER_PRIVACY
            }
        }
    }
</script>